// Generated by Melange

import * as Buhta_cabinet__TextField from "./TextField.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const field = "relative pt-1";

function label(size, param, isFocused, isEmptyValue, isDarkMode, param$1) {
  const labelFocused = isFocused || !isEmptyValue;
  return Cn.fromList({
    hd: "absolute -top-1 left-0 px-2 transition-transform ease-in-out duration-250",
    tl: {
      hd: isDarkMode ? "text-white bg-black" : "text-asphalt bg-white",
      tl: {
        hd: labelFocused ? "cursor-default" : "cursor-text",
        tl: {
          hd: Cn.on(isDarkMode ? "text-white" : "text-asphalt", isFocused),
          tl: {
            hd: "translate-x-2",
            tl: {
              hd: size === "m" ? (
                  labelFocused ? "text-preheader translate-y-0" : "text-sm translate-y-4.5"
                ) : (
                  size === "s" ? (
                      labelFocused ? "text-xxs translate-y-0" : "text-xs translate-y-4"
                    ) : (
                      labelFocused ? "text-preheader translate-y-0" : "text-base leading-4 translate-y-6"
                    )
                ),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  });
}

const Styles = {
  field: field,
  label: label
};

function make(labelOpt, placeholderOpt, type_Opt, name, disabledOpt, sizeOpt, requiredOpt, hasErrorOpt, onChangeOpt, autoCompleteOpt, isDarkModeOpt, autoFocusOpt, multilineOpt, $staropt$star) {
  const label$1 = labelOpt !== undefined ? labelOpt : "";
  const placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
  const type_ = type_Opt !== undefined ? type_Opt : "text";
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const size = sizeOpt !== undefined ? sizeOpt : "l";
  const required = requiredOpt !== undefined ? requiredOpt : false;
  const hasError = hasErrorOpt !== undefined ? hasErrorOpt : false;
  const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
      
    });
  const autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "true";
  const isDarkMode = isDarkModeOpt !== undefined ? isDarkModeOpt : false;
  const autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
  const multiline = multilineOpt !== undefined ? multilineOpt : false;
  $staropt$star !== undefined;
  return function (textPadding, $staropt$star) {
    $staropt$star !== undefined;
    return function (className, inputClassName, validatedValue, pattern, onBlur, inputRef, tabIndex, minLength, maxLength, onFocusChangedOpt, valueOpt, focusedOpt, rowsOpt) {
      const onFocusChanged = onFocusChangedOpt !== undefined ? onFocusChangedOpt : (function (param) {
          
        });
      const value = valueOpt !== undefined ? valueOpt : "";
      const focused = focusedOpt !== undefined ? focusedOpt : false;
      const rows = rowsOpt !== undefined ? rowsOpt : 4;
      const match = React.useState(function () {
        return focused;
      });
      const setFocus = match[1];
      const isFocused = match[0];
      React.useEffect((function () {
        Curry._1(setFocus, (function (param) {
          return focused;
        }));
      }), [focused]);
      const className$1 = Cn.fromList({
        hd: field,
        tl: {
          hd: isFocused ? "border-links" : "",
          tl: {
            hd: Cn.take(className),
            tl: /* [] */ 0
          }
        }
      });
      const isEmptyLabel = label$1.length === 0;
      const isEmptyValue = value.length === 0;
      const labelOpt = isEmptyLabel ? null : JsxRuntime.jsx("label", {
          children: label$1,
          className: label(size, hasError, isFocused, isEmptyValue, isDarkMode, disabled),
          onClick: (function (param) {
            Curry._1(onFocusChanged, true);
            Curry._1(setFocus, (function (param) {
              return true;
            }));
          })
        });
      let tmp = {
        value: value,
        placeholder: placeholder,
        type_: type_,
        size: size,
        hasError: hasError,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        disabled: disabled,
        required: required,
        multiline: multiline,
        isFocused: isFocused,
        isDarkMode: isDarkMode,
        onChange: onChange,
        onFocus: (function (param) {
          Curry._1(onFocusChanged, true);
          Curry._1(setFocus, (function (param) {
            return true;
          }));
        }),
        onBlur: (function (param) {
          Curry._1(onFocusChanged, false);
          Curry._1(setFocus, (function (param) {
            return false;
          }));
        }),
        rows: rows
      };
      if (inputClassName !== undefined) {
        tmp.className = Caml_option.valFromOption(inputClassName);
      }
      if (name !== undefined) {
        tmp.name = Caml_option.valFromOption(name);
      }
      if (pattern !== undefined) {
        tmp.pattern = Caml_option.valFromOption(pattern);
      }
      if (validatedValue !== undefined) {
        tmp.validatedValue = Caml_option.valFromOption(validatedValue);
      }
      if (textPadding !== undefined) {
        tmp.textPadding = Caml_option.valFromOption(textPadding);
      }
      if (tabIndex !== undefined) {
        tmp.tabIndex = Caml_option.valFromOption(tabIndex);
      }
      if (minLength !== undefined) {
        tmp.minLength = Caml_option.valFromOption(minLength);
      }
      if (maxLength !== undefined) {
        tmp.maxLength = Caml_option.valFromOption(maxLength);
      }
      if (inputRef !== undefined) {
        tmp.inputRef = Caml_option.valFromOption(inputRef);
      }
      return JsxRuntime.jsxs("div", {
        children: [
          labelOpt,
          JsxRuntime.jsx(Buhta_cabinet__TextField.make, tmp)
        ],
        className: className$1
      });
    };
  };
}

function Field(Props) {
  return Curry.app(make(Props.label, Props.placeholder, Props.type_, Props.name, Props.disabled, Props.size, Props.required, Props.hasError, Props.onChange, Props.autoComplete, Props.isDarkMode, Props.autoFocus, Props.multiline, Props.errorText)(Props.textPadding, Props.helpText), [
    Props.className,
    Props.inputClassName,
    Props.validatedValue,
    Props.pattern,
    Props.onBlur,
    Props.inputRef,
    Props.tabIndex,
    Props.minLength,
    Props.maxLength,
    Props.onFocusChanged,
    Props.value,
    Props.isFocused,
    Props.rows
  ]);
}

const make$1 = Field;

export {
  Styles,
  make$1 as make,
}
/* Buhta_cabinet__TextField Not a pure module */
